import { getMessages } from '../../../../../../../store/constants';
import { IPreviewSetting } from './types';
import { EKanbanCardProperty } from '../../../../../../../types/types';
import { NO_PRIORITY } from '../../../../../helpers/constants';

export const PREVIEW_TITLE = getMessages().getText('preview.title');
export const PREVIEW_TEXT = getMessages().getText('preview.text');
export const PREVIEW_TEXT_ADMIN = getMessages().getText('preview.text.admin');

export const PREVIEW_SETTINGS_DEFAULT: Partial<IPreviewSetting>[] = [
    {
        key: EKanbanCardProperty.EMPTY,
        name: getMessages().getText('preview.empty'),
        isHideCount: true,
        localIcon: 'empty',
    },
    {
        key: EKanbanCardProperty.START_DATE,
        name: getMessages().getText('preview.start'),
        sortFunc: (card) => !!card.startDate,
        icon: 'start-date',
    },
    {
        key: EKanbanCardProperty.DUE_DATE,
        name: getMessages().getText('preview.due'),
        sortFunc: (card) => !!card.dueDate,
        icon: 'due-date',
    },
    {
        key: EKanbanCardProperty.ASSIGNEES,
        name: getMessages().getText('preview.assignees'),
        sortFunc: (card) => card.assignees && !!card.assignees.length,
        icon: 'account',
    },
    {
        key: EKanbanCardProperty.COLOR_LABELS,
        name: getMessages().getText('preview.color-labels'),
        sortFunc: (card) => card.colorIds && !!card.colorIds.length,
        icon: 'color-tag',
    },
    {
        key: EKanbanCardProperty.ESTIMATE,
        name: getMessages().getText('preview.estimate'),
        sortFunc: (card) => !!card.estimate,
        icon: 'estimate',
    },
    {
        key: EKanbanCardProperty.PRIORITY,
        name: getMessages().getText('preview.priority'),
        sortFunc: (card) => card.priority && card.priority !== NO_PRIORITY,
        icon: 'priority-no',
    },
    {
        key: EKanbanCardProperty.PROGRESS,
        name: getMessages().getText('preview.progress'),
        sortFunc: (card) => !!card.processingPercent,
        icon: 'spent-time',
    },
    {
        key: EKanbanCardProperty.TAGS,
        name: getMessages().getText('preview.tags'),
        sortFunc: (card) => card.tags && !!card.tags.length,
        icon: 'tag',
    },
    {
        key: EKanbanCardProperty.COUNTERS,
        name: getMessages().getText('preview.counters'),
        sortFunc: (card) => card.checklistIds && !!card.checklistIds.length ||
            card.subCardIds && !!card.subCardIds.length ||
            !!card.driveDocCount ||
            !!card.commentCount ||
            !!card.description ||
            !!card.epicId,
        icon: 'workload',
    },
    {
        key: EKanbanCardProperty.PREFIXES,
        name: getMessages().getText('preview.prefixes'),
        sortFunc: (card) => !!card.cardNumber,
        localIcon: 'card-number',
        link: 'https://www.kanbanchi.com/faqwd/kanbanchi-card-prefix',
    },
    {
        key: EKanbanCardProperty.AGING,
        name: getMessages().getText('preview.ageing'),
        sortFunc: (card: any) => card.isCardAgeing,
        localIcon: 'card-ageing',
        link: 'https://www.kanbanchi.com/faqwd/how-can-i-detect-card-with-low-activity',
    },
];
